module.exports = "/images/vendor/svg-country-flags/svg/fr.svg?8bbb4186383e665cc3ee9dd093717cbe";